import { AlertTriangle } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
export function ServerDataNotice() {
  const {t}=useI18n();
  return <aside className="server-data-notice" role="note"><AlertTriangle size={17} aria-hidden="true" /><p>{t('Nếu số liệu chưa khớp, vui lòng mở ứng dụng trên điện thoại để cập nhật dữ liệu hoặc xem trực tiếp trên điện thoại.')}</p></aside>;
}
